import * as types from './constants';
import * as api from '../_api'
import { getMediaRelateInBookPage } from '../_api'
// import { LuggageNumber } from '../_api'
const getClasses = ({ commit }) => {
    api.fetchClasses
        .then((response) => {
            commit(types.GET_CLASSES, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};
const getSubjectsClasses = ({ commit }, params = {}) => {
    api.fetchSubjectsClasses(params)
        .then((response) => {
            commit(types.GET_SUBJECTS_CLASSES, response.data.items);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

const getExerciseDetail = ({ commit }, id) => {
    api.getExerciseDetail(id)
        .then((response) => {
            commit(types.GET_EXERCISE_DETAIL, response.data);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
        });
};

// data
const getExerciseFilter = ({ commit }, data) => {
    return commit(types.GET_EXERCISE_FILTER, data);
}

const getQuestionExercise = ({ commit }, id) => {
    api.getQuestionByLesson(id)
        .then((response) => {
            commit(types.GET_QUESTION_EXERCISE_INFO, response.data);
            if (response.data && response.data.exercises) {
                let lengthExercise = response.data.exercises.length;
                let dataExercise = lengthExercise > 0 ? response.data.exercises[lengthExercise - 1].exercises_question : [];
                commit(types.GET_QUESTION_EXERCISE, dataExercise);
            }
        })
        .catch();
}

const getEBooksDetail = ({ commit }, id) => {
  api.getEBooksDetail(id)
    .then((response) => {
      commit(types.GET_EBOOKS_DETAIL, response.data);
    })
    .catch();
};

const getRelateMedia = ({ commit }, params) => {
    return getMediaRelateInBookPage(params).then(res => {
        return (res && res.data && !res.errors) ? res.data : [];
    }).catch(() => { return false; });
}

const setQuestionActivity = ({ commit }, data) => {
    return commit(types.SET_QUESTION_ACTIVITY, data);
}

const toggleFormMath = ({ commit }, value) => {
    commit(types.OPEN_MATH_FORM, value);
}

const sendValueMathlive = ({ commit }, value) => {
    commit(types.SEND_MATH_VAL, value);
}

const validateQuestion = ({ commit }, data) => {
    commit(types.VALIDATE_QUESTION, data);
}

const checkQuestionCorrect = ({ commit }, data) => {
    commit(types.CHECK_CORRECT_QUESTION, data);
}

const setQuestionValidData = ({ commit }, data) => {
    commit(types.SET_QUESTION_VALID_DATA, data);
}

const actionSetShowActiveContent = ({ commit }, data) => {
    commit(types.SHOW_ACTIVE_CONTENT, data);
}

const getAllClasses = ({ commit }, id) => {
    api.getAllClasses(id)
        .then((response) => {
            commit(types.GET_ALL_CLASSES, response.data);
        })
        .catch((error) => {
            console.error(error);
        });
}

const actionSetPracticeCurr = ({ commit }, data) => {
    commit(types.SET_PACTICE_ACTIVE, data);
}

const actionSetDataPacticeType = ({ commit }, data) => {
    commit(types.SET_PACTICE_TYPES_DATA, data)
}

const actionSetLocalExerciseClassCurr = ({ commit }, data) => {
    commit(types.SET_EXERCISE_CLASS_CURR, data)
}

const actionSetQuestionsData = ({ commit }, data) => {
    commit(types.SET_QUESTIONS_DATA, data)
}

const actionBookIndexOfBook = ({ commit }, data) => {
    commit(types.SET_BOOKINDEX_OF_BOOK, data)
}

const acSetParamFilterExam = ({ commit }, data) => {
    commit(types.SET_PARAM_FILTER_EXAM, data)
}

const acSetParamFilterOtherThematic = ({ commit }, data) => {
    commit(types.SET_PARAM_FILTER_EX_OTHER_THEMATIC, data)
}

const acSetQuestionPreviewInfo = ({ commit }, data) => {
    commit(types.SET_QUESTION_PREVIEW_INFO, data)
}

const acSetCatsFlat = ({ commit }, data) => {
    commit(types.SER_CATS_FLAT_EXERCISE, data)
}

const acSetIdShowBtnsItemExercise = ({ commit }, data) => {
    commit(types.SHOW_BTNS_ITEM_EXERCISE, data)
}

export default {
    getClasses,
    getSubjectsClasses,
    getExerciseFilter,
    getExerciseDetail,
    getQuestionExercise,
    toggleFormMath,
    sendValueMathlive,
    validateQuestion,
    setQuestionActivity,
    checkQuestionCorrect,
    setQuestionValidData,
    getAllClasses,
    actionSetPracticeCurr,
    actionSetDataPacticeType,
    actionSetLocalExerciseClassCurr,
    actionSetQuestionsData,
    actionBookIndexOfBook,
    acSetParamFilterExam,
    acSetParamFilterOtherThematic,
    getEBooksDetail,
    getRelateMedia,
    acSetQuestionPreviewInfo,
    acSetCatsFlat,
    actionSetShowActiveContent,
    acSetIdShowBtnsItemExercise
};